export const ACCO_REQUEST = "ACCO_REQUEST";
export const ACCO_SUCCESS = "ACCO_SUCCESS";
export const ACCO_FAILED = "ACCO_FAILED";
